module.exports = {
	baseSelector: '.icon',
	classPrefix: 'icon-',
	cssTemplate: './talendicons.template.css',
	types: ['eot', 'woff', 'woff2', 'ttf', 'svg'],
	fileName: '[fontname].[ext]',
	files: ['svg/**/*.svg'],
	fixedWidth: false,
	fontName: 'talendicons',
};
